import type { ImAccount } from '@fruitful/types';
import * as React from 'react';
import { isWeb, ScrollView, Sheet, View, YStack } from 'smoothie';

import { ApexAccountLineItem } from './ApexAccountLineItem';

interface SelectApexAccountSheetProps {
    isOpen: boolean;
    apexAccounts: ImAccount[];
    onClose: () => void;
    onSelectAccount: (account: ImAccount) => void;
}

const SelectApexAccountSheet = ({
    isOpen,
    onClose,
    apexAccounts,
    onSelectAccount,
}: SelectApexAccountSheetProps) => {
    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            renderInAppRoot={false}
            disableDrag
            showCloseButton={true}
            title="Select account"
        >
            <YStack maxHeight={600} $sm={{ width: 400, alignSelf: 'center' }}>
                <ScrollView
                    showsVerticalScrollIndicator={isWeb}
                    paddingHorizontal={isWeb ? 8 : 0}
                >
                    {apexAccounts.map((account) => (
                        <View
                            key={account.apexAccountId}
                            borderBottomWidth={1}
                            borderBottomColor="$gray100"
                            paddingVertical={16}
                        >
                            <ApexAccountLineItem
                                onPress={() => {
                                    onSelectAccount(account);
                                    onClose();
                                }}
                                apexAccount={account}
                            />
                        </View>
                    ))}
                </ScrollView>
            </YStack>
        </Sheet>
    );
};

export default SelectApexAccountSheet;
